import type { Manga } from '@/mocks/manga';

export default function MangaCard({ manga }: { manga: Manga }) {
  return (
    <article
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
      data-product-shop
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title}封面 飞飞漫画网`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
          {manga.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-bold text-foreground-950">
          <i className="ri-star-fill text-[11px]"></i>
          {manga.rating}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-black/70 to-transparent px-2.5 pb-2 pt-6 text-[11px] text-white">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line"></i>
            {manga.views}
          </span>
          <span>{manga.latest}</span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-3 md:p-4">
        <h3 className="text-sm font-bold text-foreground-950 md:text-base">{manga.title}</h3>
        <p className="mt-1 text-xs text-foreground-600">{manga.author}</p>
        <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600">
          {manga.desc}
        </p>
        <div className="mt-3 flex flex-wrap gap-1.5">
          {manga.tags.map((t) => (
            <span
              key={t}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}